var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"j-map-coordinate-wrap",style:({ left: `${_vm.point.left + 12 || 0}px`, top: `${_vm.point.top - 42 || 0}px` })},[_c('table',[_c('tr',[_c('td',[_vm._v("经度")]),_c('td',[_vm._v(_vm._s(_vm.point.longitude))])]),_c('tr',[_c('td',[_vm._v("纬度")]),_c('td',[_vm._v(_vm._s(_vm.point.latitude))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }